import {computed, ComputedRef} from "vue"
import store from "@/vue/planning/store/store"
import getCacheKey from "@/vue/planning/logic/getCacheKey"

const currentCacheKey: ComputedRef<string> = computed(()=>{
    const BeginDate = store.state.dates.BeginDate
    const EndDate = store.state.dates.EndDate
    const season = store.state.season
    const participants = store.state.participants
    const skipass = store.state.skipass
    if (!BeginDate || !EndDate || !season) return ""
    const cacheKey = getCacheKey(store.state.packCode, BeginDate, EndDate, season, participants, skipass)
    return cacheKey
})

export default currentCacheKey